/* eslint-disable no-unused-vars */
import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom"; // この行を追加
import {
  collection,
  query,
  where,
  getDocs,
  onSnapshot,
} from "firebase/firestore";
import db from "../firebase";
import gsap from "gsap";
import Detail from "./Detail";
import Header from "./Header";

function Happy() {
  const [searchResults, setSearchResults] = useState([]);
  const [hasSearched, setHasSearched] = useState(false);
  const [selectedCocktail, setSelectedCocktail] = useState(null);

  const location = useLocation();
  const { base, taste, alcoholContent, carbonation } = location.state || {};
  const navigate = useNavigate();
  useEffect(() => {
    let q = db.collection("items");

    //変更をリアルタイムで監視するための関数
    if (base) {
      q = q.where("base", "==", base);
    }
    if (taste) {
      q = q.where("taste", "==", taste);
    }
    if (alcoholContent) {
      q = q.where("alcoholContent", "==", alcoholContent);
    }
    if (carbonation) {
      q = q.where("carbonation", "==", carbonation);
    }

    q.onSnapshot((snapshot) => {
      //引数のdocsにデータが格納されており、1つずつ取り出す
      setSearchResults(
        snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }))
      );
    });
  }, [location.state]);
  console.log(searchResults);

  const handleCocktailSelect = (cocktail) => {
    navigate("/detail", {
      state: {
        id: cocktail.id,
      },
    });
  };

  const items = [base, taste, alcoholContent,carbonation].filter(item => item !== "")
  const result = items.join(":")

  // if(taste){
  //   const tasteLi = undefined
  //   tasteLi<Any> = "<li>" + taste + "</li>"
  // }

  // const baseOptions = [
  //   "ウイスキー",
  //   "ジン",
  //   "ウォッカ",
  //   "ラム",
  //   "テキーラ",
  //   "日本酒",
  //   "焼酎",
  // ];
  // const alcoholContentOptions = ["低", "中", "高", "無"];
  // const carbonationOptions = ["有", "無"];
  // const tasteOptions = [
  //   "甘口",
  //   "中口",
  //   "辛口",
  //   "爽やか",
  //   "さっぱり",
  //   "フルーティー",
  // ];

  return (
    <div className="hpall">
      {searchResults && (
        <div>
          <div className="hpall-conte">
          <p className="hpall-first">検索結果</p>
          <ul className="hpall-p">
            {result}で検索<span>........</span>
          </ul></div>
          {searchResults.length > 0 ? (
            <>
              <ul className="cocktail-list">
                {searchResults.map((item) => (
                  <li
                    key={item.id}
                    onClick={() => handleCocktailSelect(item)}
                    className="cocktail-item"
                  >
                    <img
                      src={item.image}
                      alt={item.name}
                      className="cocktail-image"
                    />
                    <span className="cocktail-name">{item.name}</span>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <p>該当するカクテルが見つかりませんでした。</p>
          )}
        </div>
      )}

      {/* Detail コンポーネントの呼び出しを削除 */}
    </div>
  );
}

export default Happy;
